export enum UserPermission {
    CREATE_ORG_USER = 'CREATE_ORG_USER',
    UPDATE_ORG_USER = 'UPDATE_ORG_USER',
    DELETE_ORG_USER = 'DELETE_ORG_USER',
    CREATE_PROJECT = "CREATE_PROJECT",
    UPDATE_ORDER = "UPDATE_ORDER",
    DELETE_ORDER = "DELETE_ORDER",
    MERGE_TO_PDF = "MERGE_TO_PDF",
    CREATE_ORG_TITLE_TEMPLATE = 'CREATE_ORG_TITLE_TEMPLATE',
    UPDATE_ORG_TITLE_TEMPLATE = 'UPDATE_ORG_TITLE_TEMPLATE',
    UPDATE_ORG_TITLE = 'UPDATE_ORG_TITLE',
    ASSIGN_PROJECT = 'ASSIGN_PROJECT',
    UPDATE_PROJECT = 'UPDATE_PROJECT',
    DELETE_PROJECT = 'DELETE_PROJECT',
    PURCHASE_TOKENS = 'PURCHASE_TOKENS'
}
